import React from 'react';

const NotFound: React.FC = () => {
  return (
    <div className="not-found wa-stack wa-gap-2 wa-align-items-center">
      <h2>Nothing found</h2>
      <p>We couldn't find the page you were looking for.</p>
    </div>
  );
}

export default NotFound;
